    // src/app/modules/auth/register.service.ts
    import { Injectable } from '@angular/core';
    import { ApiService } from 'src/app/core/services/api.service';
    import { Observable } from 'rxjs';

    export interface RegisterRequest {
    id?: number;
    userCode: string;
    userName: string;
    phoneNumber?: string;
    passwordCurrent?: string;
    password: string;
    remark?: string;
    birthDay?: string;
    bankName?: string;
    bankAccountNumber?: string;
    bankAccountName?: string;
    bankBranch?: string;
    }

    @Injectable({ providedIn: 'root' })
    export class RegisterService {
    constructor(private api: ApiService) {}

    register(userData: RegisterRequest): Observable<any> {
        return this.api.post('user/register', userData);
    }
    }
